import {
	cyberConnectOwnerAddress,
	scWalletAccountResolver,
	scWalletIndex,
	walletAddress
} from '$lib/wallet/store';
import { checkUserSmartContractWallets } from '$lib/home/scwallet/scWallet';
import {
	addErrorNotification,
	addTransactionNotification
} from '$lib/notifications/notificationManager';
import {
	createScWalletActiveStep,
	creatingSmartContractWallet,
	popupModalData,
	popupModalOpen,
	popupModalType,
	tosBeingChecked
} from '$lib/popups/popupsStore';
import { getTosSigned } from '$lib/popups/tos/tos';
import { createSmartContractWallet } from '$lib/web3/actions/scwModifiers';
import { getParsedError } from '$lib/web3/errorHandling';
import type { SendTransactionResult } from '@wagmi/core';
import { get } from 'svelte/store';
import { logAnalytcisEvent } from './analytics';
import { smartContractWalletAddress } from '$lib/home/scwallet/store';
import { getUserSmartContractWallets } from '$lib/web3/actions/scwFetchInfo';
import { getSignerAddress, isCyberWallet } from '@cyberlab/cyber-app-sdk';

export async function checkTosAndSCWallet(SC_WALLET_ACCOUNT_RESOLVER: `0x${string}`) {
	await checkUserSmartContractWallets(SC_WALLET_ACCOUNT_RESOLVER);
}

export async function executeCreateWallet(SC_WALLET_ACCOUNT_RESOLVER_ADDRESS: `0x${string}`) {
	try {
		logAnalytcisEvent('click_create_polynomial_wallet', {});
		creatingSmartContractWallet.set(true);
		let tx: SendTransactionResult = await createSmartContractWallet(
			get(walletAddress),
			get(scWalletIndex)
		);
		addTransactionNotification(
			'Wallet Created',
			'Your polynomial wallet has been created.',
			tx,
			async () => {
				await checkUserSmartContractWallets(SC_WALLET_ACCOUNT_RESOLVER_ADDRESS);
				creatingSmartContractWallet.set(false);
				popupModalOpen.set(true);
				popupModalType.set('CreateWallet');
				createScWalletActiveStep.set('2. Deposit');
				// popupModalOpen.set(false);
			}
		);
	} catch (e: any) {
		const { title, description } = getParsedError(e);
		addErrorNotification(title, description, JSON.stringify(e));
		creatingSmartContractWallet.set(false);
	}
}

export async function triggerTosCheck(unapprovedSCWAddress?: string) {
	try {
		tosBeingChecked.set(true);
		let isTosSigned = await getTosSigned(isCyberWallet() ? getSignerAddress() : get(walletAddress));
		if (Boolean(isTosSigned) == false) {
			if (unapprovedSCWAddress) {
				popupModalData.set({ smartContractWalletAddress: unapprovedSCWAddress });
				popupModalType.set('WalletFound');
				popupModalOpen.set(true);
			} else {
				popupModalOpen.set(true);
				popupModalType.set('Tos');
			}
		}
		tosBeingChecked.set(false);
		return Boolean(isTosSigned);
	} catch (e: any) {
		return false;
	}
}

export async function onboardUser(source: string) {
	logAnalytcisEvent('click_start_trading', { source });
	try {
		await checkUserSmartContractWallets(get(scWalletAccountResolver));
		let _walletAddressExist = get(smartContractWalletAddress) != '';
		let txData: Array<string> = await getUserSmartContractWallets(
			get(walletAddress),
			get(scWalletAccountResolver)
		);
		let isTosSigned: boolean = await triggerTosCheck(txData?.[0]);
		if (isTosSigned) {
			if (!_walletAddressExist) {
				popupModalOpen.set(true);
				popupModalType.set('CreateWallet');
				createScWalletActiveStep.set('1. Create Account');
			} else {
				popupModalOpen.set(false);
			}
		}
	} catch (e: any) {
		addErrorNotification(
			'Failed to Fetch Terms of Service Status',
			"couldn't fetch terms of service status please try again",
			JSON.stringify(e, Object.getOwnPropertyNames(e)),
			true
		);
	}
}
